import React, { lazy, useMemo } from 'react';
import { getVehicleStatusColumns } from './columnMapping';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Link = lazy(() => import(`globalcomponents/UI/Link`));

const VehicleStatus = ({ vehicleStatus, i18n, viewOnMap, noPagination, noSort }) => {
  const columns = useMemo(() => {
    return getVehicleStatusColumns(noSort);
  }, [noSort]);

  const generateRows = () => {
    var filtered = vehicleStatus.filter(function (el) {
      return el != null;
    });
    const updatedList = filtered?.map((item) => {
      const row = {};
      for (let i = 0; i < item.infoWithLink.length; i++) {
        const rowItem = item.infoWithLink[i];
        row[columns[i].id] = rowItem.link ? (
          <Link href={window.location.origin + rowItem.link.replace('.', '').replace('?id=', '/')} newPage>
            {rowItem.item}
          </Link>
        ) : (
          rowItem.item
        );
        row.latestLocation =
          item.infoWithLink[3].item === '(0.0,0.0)' ? (
            <span disabled>{'View On Map'}</span>
          ) : (
            <Link onClick={() => viewOnMap && viewOnMap(item.infoWithLink[3].item)}>{'View On Map'}</Link>
          );
        row.seatBeltStatus =
          item.infoWithLink[4] != undefined && item.infoWithLink[4] !== null && item.infoWithLink[4].item === 0 ? (
            <span className="seatbeathStatus notBuckled">Not Buckled</span>
          ) : item.infoWithLink[4] != undefined && item.infoWithLink[4] !== null && item.infoWithLink[4].item === 1 ? (
            <span className="seatbeathStatus buckled">Buckled</span>
          ) : item.infoWithLink[4] != undefined && item.infoWithLink[4] !== null && item.infoWithLink[4].item === 2 ? (
            <span className="seatbeathStatus noData">Error</span>
          ) : (
            <span className="seatbeathStatus noData">No Data Available</span>
          );
      }
      return row;
    });

    return updatedList;
  };

  return (
    <>
      <Table
        type="client"
        defaultSortBy={{ sortBy: 'vin', order: 'desc' }}
        title=""
        columns={columns}
        data={generateRows()}
        emptyMessage={i18n.t('common.tableEmptyMessage')}
        itemsPerPage={10}
        actions={[]}
        i18n={i18n}
        noPagination={noPagination || false}
      />
    </>
  );
};

export default VehicleStatus;
